import { bookingMenus, getBookingPages } from "@ehealth_tools/client-booking/src/modules/booking.pages";

/**
 * Create the navigation configuration for the app
 */

import { DEFAULT_MENU_FACTORY_UID, DefaultMenuFactory, MenuDefinition, MenuFactories, NavigationServiceConfiguration } from "@cervval.js/client-html5-spa/navigation";
import { INIT_ID } from "@cervval.js/common-action/src/action.tools";
import { ACTION_SERVICE, ActionService } from "@cervval.js/common-action/src/services/action.service";
import { injector } from "@cervval.js/common/src/dependencies/injector";
import { NOW } from "@cervval.js/common/src/tools/timestamps.tools.factory";
import { anyReallyAny, ObjectTools } from "@cervval.js/common/tools";
import { BOOKING_SERVICE } from "@ehealth_tools/common-booking/src/services/abstractCommonBooking.service";
import { ElementTypes } from "@sportsante/common-shared/src/data/global/global.model";
import { CompanyAffectationDTO } from "@sportsante/common-shared/src/data/users/company.dto";
import { COMPANY_POSITION } from "@sportsante/common-shared/src/data/users/user.types";
import { ClientBookingService } from "src/shared/services/clientBookingService";
import { DROPDOWN_MENU_FACTORY_UID } from "./navigation.consts";

/**
 * Application menus by menuUid
 */
export const menuDefinitions = {
    "navHeaderRightMenu": ObjectTools.is<MenuDefinition>({
        menuFactoryUid: DEFAULT_MENU_FACTORY_UID
    }),
    ...bookingMenus
};

export type MenuUid = keyof typeof menuDefinitions;// type corresponding to keys of the menuDefinitions (ie all menu uids)

/**
 * Application pages by pageName
 */
const pages = {
    ...getBookingPages<keyof typeof menuDefinitions>({
        function: {
            importPromise: () => {
                return import("@ehealth_tools/client-booking/src/modules/pages/agenda/agendaPage").then((module) => new module.Agenda({
                    async onAccept() {
                        // Add services
                        const bookingService = injector.get<ClientBookingService>(BOOKING_SERVICE);
                        const actionService = injector.get<ActionService<ElementTypes, unknown>>(ACTION_SERVICE);
                        // Retrieve pro
                        const pro = bookingService.getCurrentUser();
                        // Retrieve patient
                        const userSession = bookingService.getCurrentSessionUser();
                        // Retrieve company of the pro
                        // FIXME Typings problem
                        const coachCompany = bookingService.getCompany(pro as anyReallyAny);

                        /*
                         FIXME
                         We don't check if an affectation already exists for patient and coach,
                         it can leads to error with messaging process (see messaging group creation and callback canConnectUsersWithinGroupDiscussion).
                         The problem is that we expect a user to have only one company_affectation per company, and this callback can break this constraint
                         */
                        await actionService.encapsulateInAction((action) => {
                            if (coachCompany != null && userSession != null) {
                                const newCompanyAffectation: CompanyAffectationDTO = {
                                    id: INIT_ID,
                                    companyId: coachCompany.id,
                                    modificationDate: NOW(),
                                    position: COMPANY_POSITION.CUSTOMER,
                                    userId: userSession.customerId,
                                    __tableName: "company_affectations"
                                };
                                // Create new company affectation
                                action.create("company_affectations", newCompanyAffectation);
                            }
                        }, { logMessage: "Add company affectations" });
                    }
                }));
            },
            pagename: "agenda"
        }
    })
};

export type PageName = (keyof typeof pages) & string;

/**
 * @returns the navigation service configuration
 */
export function getNavigationServiceConfiguration(): NavigationServiceConfiguration<PageName> {
    const menuFactories: MenuFactories = {};
    menuFactories[DEFAULT_MENU_FACTORY_UID] = new DefaultMenuFactory({
        linkActiveCssClass: "active",
        liCssClasses: "nav-item",
        linkCssClasses: "nav-link",
        iconCssClasses: "fa-fw me-1",
        linkLabelSpanCssClasses: "d-none d-lg-inline"
    });
    menuFactories[DROPDOWN_MENU_FACTORY_UID] = new DefaultMenuFactory({ liActiveCssClass: "active", linkActiveCssClass: "active", linkCssClasses: "dropdown-item" });

    const conf: NavigationServiceConfiguration<PageName> = {
        pages: pages,
        defaultPage: "map",
        menus: menuDefinitions,
        menuFactories
    };
    return conf;
}